import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { MailAddressSelectDetailItem } from '../../../external/MailAddressSelectApi';
import { actions } from '../../modules/Actions';

export interface MailAddressSelectState {
  hit: number;
  mailContactResult: MailAddressSelectDetailItem[];
}

export const initialState: MailAddressSelectState = {
  hit: 0,
  mailContactResult: []
};

export const MailAddressSelectReducer = reducerWithInitialState(initialState)
.case(actions.fetchMailAddressSelect,(state: MailAddressSelectState, payload: MailAddressSelectState) => {
    return payload;
  }
);
